import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

const FETCH_TOKENS = ({ commit }) => {
  return ApiServices.getIntegrationTokens()
    .then(response => {
      commit('setTokenList', response)
    })
}

const CREATE_TOKEN = ({}, data) => {
  return ApiServices.createIntegrationToken(data)
    .then(response => {
      that.SUCCESS_TOAST_MSG(response.message || 'Token created successfully')
      return response
    })
}

const REVOKE_TOKEN = ({ commit }, id) => {
  return ApiServices.revokeIntegrationToken(id)
    .then(response => {
      commit('revokeToken', id)
      that.SUCCESS_TOAST_MSG(response.message || 'Token revoked')
    })
}

export default {
  FETCH_TOKENS,
  CREATE_TOKEN,
  REVOKE_TOKEN
}



// WEBPACK FOOTER //
// ./src/store/modules/integrationTokens/actions.js